import { render, staticRenderFns } from "./view-declaration-modal.vue?vue&type=template&id=b06c55ac&scoped=true"
import script from "./view-declaration-modal.vue?vue&type=script&lang=js"
export * from "./view-declaration-modal.vue?vue&type=script&lang=js"
import style0 from "./view-declaration-modal.vue?vue&type=style&index=0&id=b06c55ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06c55ac",
  null
  
)

export default component.exports